import React, { useState } from 'react';
import { Box, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Checkbox, FormControlLabel } from '@mui/material';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import ApiHelper from 'utils/apiHelper';

const EditOrganizationDialog = ({ onClose, data }) => {
    const [organizationDescription, setOrganizationDescription] = useState(data.description);
    const [organizationAddress, setOrganizationAddress] = useState(data.address);
    const [accountLocked, setAccountLocked] = useState(data.locked);

    const handleSubmit = () => {
        ApiHelper.put(`/api/management/organizations/${data.orgid}/`, {
            description: organizationDescription,
            address: organizationAddress,
            account_locked: accountLocked
        })
            .then(() => {
                toast.success('Successfully updated.');
                onClose();
            })
            .catch(() => {
                toast.error('Failed to edit the organization');
            });
    };

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '16px' }}>Edit Organization</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Organization Name"
                        value={data.name}
                        disabled={true}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Organization Description"
                        value={organizationDescription}
                        onChange={(e) => setOrganizationDescription(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Organization Address"
                        value={organizationAddress}
                        onChange={(e) => setOrganizationAddress(e.target.value)}
                    />
                </Box>
                <Box sx={{ mt: 3 }}>
                    <FormControlLabel
                        control={<Checkbox checked={accountLocked} onChange={(e) => setAccountLocked(e.target.checked)} color="primary" />}
                        label="Account Locked"
                        sx={{ width: '45%' }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSubmit} variant="outlined">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

EditOrganizationDialog.propTypes = {
    onClose: PropTypes.func,
    data: PropTypes.object
};

export default EditOrganizationDialog;
